'use client';

import { AccountOrder } from '../types';

interface PostOnlyCellProps {
	order: AccountOrder;
}

const EMPTY_VALUE = <span className="text-text-tertiary">-</span>;

export function PostOnlyCell({ order }: PostOnlyCellProps) {
	return order.postOnly ? <span>Yes</span> : EMPTY_VALUE;
}
